module.exports = __webpack_public_path__ + "img/keyboard_7.ad537005.png";